import React, { useState, useEffect, useRef } from 'react';
import { Table, Popover } from 'antd';
import { useHistory } from 'react-router-dom';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import MessagesTop from '../../component/messagesTop/messagesTop';
import moment from 'moment';//日期格式化导包
import { studentCheckLogin } from '../newMain/studentMain';
import { ContextHandler } from '../../public/js/contextHandler';

import './studentModule.css'
import positionIconImg from '../../public/img/newMain/PositionIconWhite.png'
import stdApplying1 from '../../public/img/std/stdApplying1.png'
import stdApplying2 from '../../public/img/std/stdApplying2.png'

import { InfoCircleOutlined } from '@ant-design/icons';
import KeyDocumentFileTypeModal from '../../component/keyDocumentFileTypeModal/keyDocumentFileTypeModal';

const StudentModule = (props) => {

    const messageRef = useRef();
    const history = useHistory();
    const studentModuleId = localStorage.getItem(Config.tokenPrefix + 'studentModuleId');
    const [studentModuleModel, setStudentModuleModel] = useState({});

    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});

    const [tablesAssignment, setTablesAssignment] = useState([]);
    const [tablesCountAssignment, setTablesCountAssignment] = useState(0);
    const [currentAssignment, setCurrentAssignment] = useState(1);
    const [pageSizeAssignment, setPageSizeAssignment] = useState(10);
    const searchModelAssignment = useRef({});

    const [tablesKeyDocument, setTablesKeyDocument] = useState([]);
    const [tablesCountKeyDocument, setTablesCountKeyDocument] = useState(0);
    const [currentKeyDocument, setCurrentKeyDocument] = useState(1);
    const [pageSizeKeyDocument, setPageSizeKeyDocument] = useState(10);
    const [searchModelKeyDocument, setSearchModelKeyDocument] = useState({});

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        searchModuleById();
        search(pageSize, current);
        searchAssignment(pageSizeAssignment, currentAssignment)
        searchKeyDocument(pageSizeKeyDocument, currentKeyDocument);
    }, []);

    const searchModuleById = () => {
        let model = {studentModuleId: studentModuleId};
        model.studentId = Config.studentInfo?.studentId;
        Base.callBackApi("studentModule/searchById", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let model = data?.object ?? {};
                setStudentModuleModel(model);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const search = (pageSizeNew, currentPageNew) => {
        let model = {
            ...searchModel, 
            studentModuleId: studentModuleId,
            studentId : Config.studentInfo?.studentId
        };
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        Base.callBackApi("wpaAppl/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setTables(data?.object?.list ?? []);
                setTablesCount(data?.object?.total ?? 0);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                console.log("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchKeyDocument = (pageSizeNew, currentNew) => {
        let model = {...searchModelKeyDocument, studentModuleId: studentModuleId, studentId : Config.studentInfo?.studentId};
        model.pageSize = pageSizeNew;
        model.startRow = (currentNew - 1) * pageSizeNew;
        model.page = currentNew;
        Base.callBackApi("keyDocument/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                setTablesCountKeyDocument(data?.object?.count)
                setTablesKeyDocument(data?.object?.list ?? [])
                setCurrentKeyDocument(currentNew);
                setPageSizeKeyDocument(pageSizeNew);
            } else {
                console.log(data?.msg)
            }
        })
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew);
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1);
    }

    const tableColumns = {
        wpaApplId: "wpa_appl_id",
        companyName: "company_name",
        industrySupervisorName: "industry_supervisor_name",
        wilHours: "wil_hours",
        mark: "mark",
        applyDate: "apply_date",
        lastUpdatedDate: "last_updte_dte",
        sentToIs: "sent_to_is",
        wpaStatus: "wpa_status",
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1);
            }
        }
    }
    
    const searchAssignment = (pageSizeNew, currentPageNew) => {
        let model = {...searchModelAssignment.current, studentModuleId: studentModuleId, studentId : Config.studentInfo?.studentId};
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        Base.callBackApi("assign/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setTablesAssignment(data?.object?.list ?? []);
                setTablesCountAssignment(data?.object?.total ?? 0);
                setCurrentAssignment(currentPageNew);
                setPageSizeAssignment(pageSizeNew);
            } else {
                console.log("error", data.msg);
            }
        }).catch(err => { });
    }

    const onChangeAssignment = (currentNew, pageSizeNew) => {
        searchAssignment(pageSizeNew, currentNew);
    }

    const onShowSizeChangeAssignment = (currentNew, pageSizeNew) => {
        searchAssignment(pageSizeNew, 1);
    }
    
    const tableColumnsAssignment = {
        firstName: "first_name",
        studentAcctId: "student_acct_id",
        turnitinScore: "turnitin_score",
        turnitinUrl: "turnitin_url",
        assignMarks: "assign_marks",
        assignName: "assign_name",
        submittedDate: "submitted_date",
        status: "status",
        assignDeadline: "assign_deadline",
    }

    const handleTableChangeAssignment = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumnsAssignment[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumnsAssignment[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModelAssignment.current.orderBy) {
            if (orderBy !== searchModelAssignment.current.orderBy) {
                searchModelAssignment.current.orderBy = orderBy;
                searchAssignment(10, 1)
            }
        }
    }

    const onChangeKeyDocument = (currentNew, pageSizeNew) => {
        searchKeyDocument(pageSizeNew, currentNew);
    }

    const onShowSizeChangeKeyDocument = (currentNew, pageSizeNew) => {
        searchKeyDocument(pageSizeNew, 1);
    }

    const tableColumnsKeyDocument = {
        fileTypeVal: "file_type_val",
        fileDesc: "file_desc",
        userName: "user_name",
        uploadedDate: "uploaded_date",
        status: "status",
    }

    const handleTableChangeKeyDocument = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumnsKeyDocument[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumnsKeyDocument[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModelKeyDocument.orderBy) {
            if (orderBy !== searchModelKeyDocument.orderBy) {
                searchModelKeyDocument.orderBy = orderBy;
                searchKeyDocument(pageSizeKeyDocument, 1,);
            }
        }
    }

    const jump = (path) => {
        history.push(path)
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'WPA ID',
            dataIndex: 'wpaApplId',
            width: '8%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'wpaApplId') },
        },
        {
            title: 'Company',
            dataIndex: 'companyName',
            width: '15%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyName') },
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableEllipsisBox'>{text}</div>
                </Popover>
            ),
        },
        {
            title: 'Industry Supervisor',
            dataIndex: 'industrySupervisorName',
            width: '15%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'industrySupervisorName') },
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableEllipsisBox'>{text}</div>
                </Popover>
            ),
        },
        {
            title: 'WIL Hours',
            dataIndex: 'wilHours',
            width: '10%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'wilHours') },
            render: (text) => Base.parseToFixed(text, 1),
        },
        {
            title: 'Mark',
            dataIndex: 'mark',
            width: '10%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'mark') },
            render: (text) => Base.parseToFixed(text, 1),
        },
        {
            title: 'Submit Date',
            dataIndex: 'applyDate',
            width: '13%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'applyDate') },
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Last Update',
            dataIndex: 'lastUpdatedDate',
            width: '13%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'lastUpdatedDate') },
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Sent to IS over 14 days',
            dataIndex: 'sentToIs',
            width: '16%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'sentToIs') },
        },
        {
            title: 'Status',
            dataIndex: 'wpaStatus',
            width: 180,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'wpaStatus') },
            render: text => (
                <div className='tableStatusBox'>
                    <div className={'tableStatus ' + text}>{ContextHandler.getMapValue('wpaFormStatusMap', text)}</div>
                </div>
            ),
        },
        {
            fixed: 'right',
            width: 0,
        },
    ];
    const columnsAssignment = [
        {
            title: 'Assignment Name',
            dataIndex: 'assignName',
            width: '25%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'assignName') },
        },
        {
            title: 'Deadline',
            dataIndex: 'assignDeadline',
            width: '20%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'assignDeadline') },
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Submit Date',
            dataIndex: 'submittedDate',
            width: '20%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'submittedDate') },
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Turnitin Score',
            dataIndex: 'turnitinScore',
            width: '20%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'turnitinScore') },
            render: (text) => text === 0? '0%' : text? `${text}%` : ''
        },
        {
            title: 'Mark',
            dataIndex: 'assignMarks',
            width: '15%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'assignMarks') },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: 180,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'status') },
            render: text => (
                <div className='tableStatusBox'>
                    <div className={'tableStatus ' + text}>{ContextHandler.getMapValue('assignmentStatusMap', text)}</div>
                </div>
            ),
        },
        {
            fixed: 'right',
            width: 0,
        },
    ];
    const columnsKeyDocument = [
        {
            title: () => 
                <div className='tableTitleCenterBox labelCircleBox'>
                    Type
                    <Popover placement="right" content={<div style={{ maxWidth: "1200px", textAlign: 'justify' }}>
                        <KeyDocumentFileTypeModal />
                    </div>} trigger="hover">
                        <div className='labelCircle'><InfoCircleOutlined /></div>
                    </Popover>
                </div>,
            dataIndex: 'fileTypeVal',
            width: '20%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'fileTypeVal') },
            render: (text, record) => text + (record?.exemptedHours ? ' (' + record?.exemptedHours + ' Hours)' : '')
        },
        {
            title: 'Description',
            dataIndex: 'fileDesc',
            width: '45%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'fileDesc') },
        },
        {
            title: 'Uploaded Date',
            dataIndex: 'uploadedDate',
            width: '20%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'uploadedDate') },
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Uploaded By',
            dataIndex: 'userName',
            width: '15%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'userName') },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: 180,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'status') },
            render: text => (
                <div className='tableStatusBox'>
                    <div className={'tableStatus ' + text}>{ContextHandler.getMapValue('KeyDocumentStatusMap', text)}</div>
                </div>
            ),
        },
        {
            fixed: 'right',
            width: 0,
        },
    ];

    /*eslint-enable*/

    return (
        <div id="container" className='websiteTemplate studentModule'>
            <div className='websiteSysButtonRow'>
                <div className="detailTitle">
                    Module Summary
                </div>
                <div className="websiteSysButtonBox">
                    <div className='websiteSysButton' onClick={() => jump('/student/WPAManagement')}><img src={positionIconImg} />WPA Management</div>
                    <div className='websiteSysButton' style={{ color: '#7733B0', backgroundColor: '#F2EBF7' }} onClick={() => jump('/student/studentAssignments')}><img src={stdApplying2} />Assignments</div>
                    <div className='websiteSysButton' style={{ color: '#0059AC', backgroundColor: '#C1DFFB' }} onClick={() => jump('/student/keyDocument')}><img src={stdApplying1} />Key Documents</div>
                </div>
            </div>
            <div className='moduleBox'>
                <div className='moduleBoxCenter'>
                    <div>
                        <div className='cardSubTitle'>{studentModuleModel?.moduleCode}</div>
                        <div className='cardSubTitle'>{studentModuleModel?.moduleName}</div>
                        <div className='flexBox'>
                            <div className='label'>Student Name</div>
                            <div className='value'>{studentModuleModel?.firstName && studentModuleModel?.lastName && studentModuleModel?.firstName + ' ' + studentModuleModel?.lastName}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Student ID</div>
                            <div className='value'>{studentModuleModel?.studentAcctId}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Programme</div>
                            <div className='value'>{studentModuleModel?.progTitle}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Cohort Year</div>
                            <div className='value'>{studentModuleModel?.cohortYear}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Assigned Academic Supervisor</div>
                            <div className='value'>{studentModuleModel?.academicSupervisorUserName}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Module Convener</div>
                            <div className='value'>{studentModuleModel?.moduleConvenerName}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Student Record Status</div>
                            <div className='value'>{ContextHandler.getMapValue('studentModuleStatusMap', studentModuleModel?.status)}</div>
                        </div>
                    </div>
                    <div>
                        <div className='countTitleBox'>
                            <div className='cardSubTitle'>WIL Hours</div>
                        </div>
                        <div className='flexBox '>
                            <div className='label'>Total Curriculum Hours</div>
                            <div className='value '>{studentModuleModel?.curriculumHours}</div>
                        </div>
                        <div className='flexBox '>
                            <div className='label'>Other Learning Activities Hours</div>
                            <div className='value '>{studentModuleModel?.otherLearningTrainingHours}</div>
                        </div>
                        <div className='flexBox '>
                            <div className='label'>WIL Hours Exempted</div>
                            <div className='value '>{studentModuleModel?.exemptedHours}</div>
                        </div>
                        <div className='flexBox '>
                            <div className='label'>WIL Hours Needed</div>
                            <div className='value '>{studentModuleModel?.neededWilHours}</div>
                        </div>
                        <div className='flexBox '>
                            <div className='label'>WIL Hours Completed</div>
                            <div className='value '>{studentModuleModel?.completedWilHours} ({studentModuleModel?.neededWilHours > 0 ? Base.parseToPercent(studentModuleModel?.completedWilHours / studentModuleModel?.neededWilHours) : 100}%)</div>
                        </div>
                        <div className='flexBox '>
                            <div className='label'># of WPA in progress</div>
                            <div className='value '>{studentModuleModel?.inProgressWpaCount}</div>
                        </div>
                        <div className='flexBox '>
                            <div className='label'># of WPA status Sent to IP that is over 14 days</div>
                            <div className='value '>{studentModuleModel?.sentToIsCount}</div>
                        </div>
                        <div className='flexBox '>
                            <div className='label'># of WPA Completed</div>
                            <div className='value '>{studentModuleModel?.completedWpaCount}</div>
                        </div>
                    </div>
                    <div>
                        <div className='countTitleBox'>
                            <div className='cardSubTitle'>Assignments</div>
                        </div>
                        <div className='flexBox '>
                            <div className='label'># of Assignments submitted vs. target</div>
                            <div className='value '>{studentModuleModel?.studentModuleAssignModelList ? studentModuleModel?.studentModuleAssignModelList?.filter(item => item.status == 'SUBMITTED')?.length + '/' + studentModuleModel?.studentModuleAssignModelList?.length : '0/0'}</div>
                        </div>
                        <div className='countTitleBox'>
                            <div className='cardSubTitle'>Marks</div>
                        </div>
                        {studentModuleModel?.studentModuleAssignModelList?.map(item =>
                            <div className='flexBox ' key={item?.studentModuleAssignId}>
                                <div className='label'>{item?.assignName} mark</div>
                                <div className='value '>{item?.assignMarks == 0 ? '0/100' : (item?.assignMarks ? Base.parseToFixed(item?.assignMarks, 2) + '/100' : 'Incomplete')}</div>
                            </div>
                        )}
                        <div className='flexBox '>
                            <div className='label'>Total WPA mark</div>
                            <div className='value '>{studentModuleModel?.wpaMarks == 0 ? '0/100' : (studentModuleModel?.wpaMarks ? Base.parseToFixed(studentModuleModel?.wpaMarks, 2) + '/100'  : 'N/A')}</div>
                        </div>
                        <div className='flexBox '>
                            <div className='label'>Total Module Mark and grade</div>
                            <div className='value '>{studentModuleModel?.totalModuleMark == 0 ? '0/100' : (studentModuleModel?.totalModuleMark ? Base.parseToFixed(studentModuleModel?.totalModuleMark, 2) + '/100 (' + Base.calcGrade(studentModuleModel?.totalModuleMark) + ')' : 'N/A')} </div>
                        </div>
                    </div>
                </div>
            </div>
            <MessagesTop ref={messageRef} />
            <div className='flexBoxMax'>
                <div className='homeTitle'>
                    WPA Management
                </div>
            </div>
            <div className="sysTable" id="tableWpa">
                <Table
                    scroll={{ x: 1200 }}
                    rowKey="wpaApplId"
                    columns={columns} //列名
                    dataSource={tables} //数据
                    pagination={{  //分页
                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                        onChange: onChange,            //上页下页或者跳页方法
                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                        total: tablesCount,             //总共多少条数据
                        current: current,         //当前页
                        pageSize: pageSize,       //每页显示多少条数据
                        defaultCurrent: 1,                               //默认当前页为1
                        size: "small"
                    }}
                    onChange={handleTableChange}
                />
            </div>
            <div className='flexBoxMax'>
                <div className='homeTitle'>
                    Assignments
                </div>
            </div>
            <div className="sysTable" id="tableAssignment">
                <Table
                    scroll={{ x: 1200 }}
                    rowKey="studentModuleAssignId"
                    columns={columnsAssignment} //列名
                    dataSource={tablesAssignment} //数据
                    pagination={{  //分页
                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                        onChange: onChangeAssignment,            //上页下页或者跳页方法
                        onShowSizeChange: onShowSizeChangeAssignment,    //每页显示多少条数据方法
                        total: tablesCountAssignment,             //总共多少条数据
                        current: currentAssignment,         //当前页
                        pageSize: pageSizeAssignment,       //每页显示多少条数据
                        defaultCurrent: 1,                               //默认当前页为1
                        size: "small"
                    }}
                    onChange={handleTableChangeAssignment}
                />
            </div>
            <div className='flexBoxMax'>
                <div className='homeTitle labelCircleBox'>
                    Key Documents
                    <Popover placement="right" content={<div style={{ maxWidth: "500px", textAlign: 'justify' }}>
                        This section is to record Key documents in their Final status, for purpose of future Reference/Audit. There is a limit of 15 documents and max 5MB each.
                    </div>} trigger="hover">
                        <div className='labelCircle'><InfoCircleOutlined /></div>
                    </Popover>
                </div>
            </div>
            <div className="sysTable" id="tableJobFile">
                <Table
                    scroll={{ x: 1200 }}
                    rowKey="keyDocumentId"
                    columns={columnsKeyDocument} //列名
                    dataSource={tablesKeyDocument} //数据
                    pagination={{  //分页
                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                        onChange: onChangeKeyDocument,            //上页下页或者跳页方法
                        onShowSizeChange: onShowSizeChangeKeyDocument,    //每页显示多少条数据方法
                        total: tablesCountKeyDocument,             //总共多少条数据
                        current: currentKeyDocument,         //当前页
                        pageSize: pageSizeKeyDocument,       //每页显示多少条数据
                        defaultCurrent: 1,                               //默认当前页为1
                        size: "small"
                    }}
                    onChange={handleTableChangeKeyDocument}
                />
            </div>
        </div>
    )

}

export default StudentModule;